"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fakePromise = exports.getData = void 0;

var request_1 = __importDefault(require("../request"));

exports.getData = function (uuid, lang, isHtml) {
  return request_1.default.post('/product/cms');
};

exports.fakePromise = function (_uuid, _lang, _isHtml) {
  return Promise.resolve({
    content: "<p>some HTML <span style=\"color: green\">CODE</span>.</p>\n      <ul>\n        <li>The Date today (var substiution): ${date}</li>\n        <li>internal link: <a href=\"/crud\">CRUD</a></li>\n        <li>external link: <a href=\"https://google.com\">Google</a></li>\n      </ul>"
  });
};